import { Divider, makeStyles } from '@material-ui/core';
import { OrderLeg } from 'doc-mate-store/lib/models/OrderLeg';
import React from 'react';
import LoadDetailMultiLeg from '../LoadDetail/multileg';
import LoadDocumentMultiLeg from '../LoadDocument/multileg';
import LoadReport from '../LoadReport';
import LoadStatusTimelineMultiLeg from '../LoadStatusTimeline/multileg';

type Props = {
  firstLoad: OrderLeg;
  lastLoad: OrderLeg;
};

const TrackerLoadDetailMultiLeg: React.FC<Props> = ({
  firstLoad,
  lastLoad,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.loadDetailArea}>
      <LoadStatusTimelineMultiLeg firstLoad={firstLoad} lastLoad={lastLoad} />
      <Divider />
      <LoadDetailMultiLeg load={firstLoad} lastLoad={lastLoad} />
      <Divider />
      <LoadDocumentMultiLeg load={firstLoad} lastLoad={lastLoad} />
      <LoadReport load={firstLoad} />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  loadArea: {
    background: 'white',
    position: 'absolute',
    top: '70%',
    left: 0,
    right: 0,
    [theme.breakpoints.up('md')]: {
      flex: 1,
      height: '100%',
      overflow: 'auto',
      maxWidth: 480,
      minWidth: 480,
      position: 'static',
    },
  },
  loadDetailArea: {
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up('md')]: {
      flex: 1,
    },
  },
  refresh: {
    background: theme.palette.grey[100],
    margin: theme.spacing(1),
    padding: theme.spacing(0.5),
  },
}));

export default TrackerLoadDetailMultiLeg;
